import {FC} from 'react'
import {EmployeeDependent} from 'types/api/employees/employeeDependent'
import {YearStyleType} from 'libs/formatter'
import styles from 'employees/show/Parts.scss'

// @ts-ignore
import {recordDisplay} from 'utils'
// @ts-ignore
import {genderOptions, handicapTypes} from 'FormFields'
// @ts-ignore
import ReadMoreReadLess from 'components/ReadMoreReadLess'
// @ts-ignore
import {Dl, Dd, Dt, Grid, SubPanel} from 'employees/show/Parts'

interface DependentProps {
  dependent: EmployeeDependent
  index: number
  yearStyle: YearStyleType
}

export const Dependent: FC<DependentProps> = ({dependent, index, yearStyle}) => {
  return (
    <SubPanel>
      <SubPanel.Headding>家族情報 #{index + 1}</SubPanel.Headding>
      <Grid className={[styles.forHalfGrid]}>
        <Dl>
          <Dt>続柄</Dt>
          <Dd>{dependent.relation_type === 'spouse' ? '配偶者' : recordDisplay(dependent.relation_other)}</Dd>
        </Dl>
        <Dl>
          <Dt>氏名</Dt>
          <Dd>
            {recordDisplay.fullName(dependent)}
            <br />
            {recordDisplay.fullName(dependent, false, true)}
          </Dd>
        </Dl>
        <Dl>
          <Dt>性別</Dt>
          <Dd>{recordDisplay.option(dependent.gender, genderOptions)}</Dd>
        </Dl>
        <Dl>
          <Dt>生年月日</Dt>
          <Dd>{recordDisplay.birthday(dependent, yearStyle)}</Dd>
        </Dl>
        <Dl>
          <Dt className={styles.specialHeight}>住所</Dt>
          <Dd>{dependent.residence_status === 'same_address' ? '同居' : recordDisplay.address(dependent)}</Dd>
        </Dl>
        <Dl>
          <Dt>電話番号</Dt>
          <Dd>{recordDisplay.numbers(dependent, 'phone_number', 3)}</Dd>
        </Dl>
        <Dl>
          <Dt>障害者区分</Dt>
          <Dd>{recordDisplay.option(dependent.handicap_type, handicapTypes)}</Dd>
        </Dl>
        <Dl>
          <Dt>障害者区分 詳細情報</Dt>
          <Dd>
            <ReadMoreReadLess key={dependent.handicap_detail}>
              {recordDisplay(dependent.handicap_detail)}
            </ReadMoreReadLess>
          </Dd>
        </Dl>
        <Dl>
          <Dt>障害者手帳画像</Dt>
          <Dd>{recordDisplay.file(dependent.handicap_certificate)}</Dd>
        </Dl>
        <Dl>
          <Dt>職業</Dt>
          <Dd>{recordDisplay(dependent.job)}</Dd>
        </Dl>

        <Dl>
          <Dt>社会保険の扶養対象</Dt>
          <Dd>{dependent.dependent_social_insurance ? '対象' : '対象外'}</Dd>
        </Dl>
        <Dl>
          <Dt>社会保険の被扶養者になった日</Dt>
          <Dd>{recordDisplay.date(dependent.dependent_from, yearStyle)}</Dd>
        </Dl>
        <Dl>
          <Dt>社会保険の扶養に追加された理由</Dt>
          <Dd>{recordDisplay(dependent.dependent_reason)}</Dd>
        </Dl>

        <Dl>
          <Dt>税の扶養対象</Dt>
          <Dd>{dependent.dependent_tax_law ? '対象' : '対象外'}</Dd>
        </Dl>
        <Dl>
          <Dt>税の被扶養者になった日</Dt>
          <Dd>{recordDisplay.date(dependent.dependent_tax_law_from, yearStyle)}</Dd>
        </Dl>
        <Dl>
          <Dt>税の扶養に追加された理由</Dt>
          <Dd>{recordDisplay(dependent.dependent_tax_law_reason)}</Dd>
        </Dl>
        <Dl>
          <Dt>年間収入</Dt>
          <Dd>{recordDisplay.yen(dependent.annual_income)}</Dd>
        </Dl>
        <Dl>
          <Dt>年間所得（1月～12月）</Dt>
          <Dd>{recordDisplay.yen(dependent.annual_earnings)}</Dd>
        </Dl>

        {dependent.residence_status === 'different_address' && (
          <Dl>
            <Dt>国内居住親族への年間送金額</Dt>
            <Dd>{recordDisplay.yen(dependent.domestic_remittance)}</Dd>
          </Dl>
        )}
        {dependent.residence_status === 'different_and_foreign_address' && (
          <>
            <Dl>
              <Dt>国外居住親族への年間送金額</Dt>
              <Dd>{recordDisplay.yen(dependent.remittance)}</Dd>
            </Dl>
            <Dl>
              <Dt>非居住者区分</Dt>
              <Dd>{dependent.is_non_resident ? '非居住者' : '対象外'}</Dd>
            </Dl>
            {dependent.relation_type !== 'spouse' && (
              <Dl>
                <Dt>留学区分</Dt>
                <Dd>{dependent.is_study_abroad ? '留学' : '対象外'}</Dd>
              </Dl>
            )}
          </>
        )}
        {dependent.relation_type === 'spouse' && (
          <Dl>
            <Dt>外国人区分</Dt>
            <Dd>{dependent.national_type && (dependent.national_type === 'foreigner' ? '外国人' : '日本人')}</Dd>
          </Dl>
        )}
        {dependent.national_type === 'foreigner' && (
          <Dl>
            <Dt>ローマ字氏名</Dt>
            <Dd>
              {recordDisplay(dependent.romaji_name)} ({recordDisplay(dependent.romaji_name_kana)})
            </Dd>
          </Dl>
        )}
        {dependent.relation_type === 'spouse' && (
          <>
            <Dl>
              <Dt>基礎年金番号</Dt>
              <Dd>{recordDisplay.numbers(dependent, 'basic_pension_number', 2)}</Dd>
            </Dl>
          </>
        )}
        {dependent.residence_status === 'different_and_foreign_address' && dependent.is_non_resident && (
          <>
            <Dl>
              <Dt>親族関係書類</Dt>
              <Dd>{recordDisplay.file(dependent.related_to_relatives_document)}</Dd>
            </Dl>
            <Dl>
              <Dt>送金関係書類</Dt>
              <Dd>{recordDisplay.file(dependent.related_to_remittance_document)}</Dd>
            </Dl>
          </>
        )}
        {dependent.relation_type !== 'spouse' &&
          dependent.residence_status === 'different_and_foreign_address' &&
          dependent.is_study_abroad &&
          dependent.is_non_resident && (
            <>
              <Dl>
                <Dt>留学証明書類</Dt>
                <Dd>{recordDisplay.file(dependent.proving_study_abroad_document)}</Dd>
              </Dl>
            </>
          )}
      </Grid>
    </SubPanel>
  )
}
